/**
 * Endpoints de autenticacao que nao devem receber o header Authorization
 * automaticamente pelo api-client.
 */
export const AUTH_ENDPOINTS = [
  '/api/PortalContador/Login',
  '/api/PortalContador/RenovarToken',
  '/api/PortalContador/Logout',
  '/api/PortalContador/Registro',
  '/api/PortalContador/RecuperarSenha',
  '/api/PortalContador/EnviarNovoCodigo',
  '/api/PortalContador/VerificarConta',
];

export const STORAGE_KEYS = {
  TOKEN: 'token_contador',
  REFRESH_TOKEN: 'refresh_token_contador',
  TOKEN_EXPIRY: 'token_expiry_contador',
  DADOS_CONTADOR: 'dados_contador',
  TIPO_USUARIO: 'tipoUsuario',
} as const;

export const DOCUMENT_TYPES = {
  XMLsPeriodo: { label: 'XMLs do Período', icon: 'FileCode' },
  SPEDFiscal: { label: 'SPED Fiscal', icon: 'FileSpreadsheet' },
  SPEDContribuicoes: { label: 'SPED Contribuições', icon: 'FileSpreadsheet' },
  NotasResumidas: { label: 'Notas Emitidas Resumidas', icon: 'FileText' },
  NotasDetalhadas: { label: 'Notas Emitidas Detalhadas', icon: 'FileText' },
  NotasCstPisCofins: { label: 'Notas CST PIS/COFINS', icon: 'FileText' },
  NotasCfopCst: { label: 'Notas CFOP/CST ICMS', icon: 'FileText' },
} as const;

export const STATUS_MAP: Record<
  string,
  { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }
> = {
  Pendente: { label: 'Pendente', variant: 'secondary' },
  Processando: { label: 'Processando', variant: 'default' },
  Concluido: { label: 'Concluído', variant: 'outline' },
  Erro: { label: 'Erro', variant: 'destructive' },
};
